export default __webpack_public_path__ + "static/media/drums game.90946831.png";